<div class="flex flex-col justify-start items-stretch h-full w-full">
    <mat-toolbar class="bg-(--mat-sys-secondary-container)! flex justify-between items-center shrink-0! max-sm:h-auto!">
        <div class="flex justify-start items-center gap-3">
            @if (user()) {
                <button type="button" mat-mini-fab (click)="home()">
                    <mat-icon>home</mat-icon>
                </button>
            }
            <div class="text-3xl">{{ selectedAuction()?.Name ?? 'JAuction' }}</div>
        </div>
        <div class="flex flex-col justify-start items-end py-[7px]">
            <div class="flex justify-end items-center gap-3">
                @if (!isLoggedIn()) {
                    <button type="button" mat-flat-button (click)="login()">Login</button>
                }
                <button type="button" mat-mini-fab (click)="about()">
                    <mat-icon>help</mat-icon>
                </button>
                @if (user()) {
                    <button type="button" mat-mini-fab (click)="logout()">
                        <mat-icon>exit_to_app</mat-icon>
                    </button>
                    <user-info class="hidden md:block"></user-info>
                }
            </div>
            @if (user()) {
                <user-info class="block md:hidden text-xs mt-[5px]"></user-info>
            }
        </div>
    </mat-toolbar>
    <!-- <div class="banner h-[300px]"></div> -->
    <div class="grow overflow-y-auto">
        <router-outlet></router-outlet>
    </div>
</div>
